import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronDown, User, LogOut, Award, LifeBuoy, Settings } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
// import SupportModal from './SupportModal'; // REMOVIDO

const linkStyle = "block px-4 py-2 text-sm text-muted-foreground hover:bg-accent transition-colors";

function UserProfileDropdown() {
    const { participanteNome, participanteEmail, participanteRole, logout } = useAuth();
    const navigate = useLocation();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    // const [showSupportModal, setShowSupportModal] = useState(false); // REMOVIDO
    const dropdownRef = useRef(null);

    // Lógica para fechar o dropdown ao clicar fora
    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [dropdownRef]);

    // Fecha o dropdown quando a rota muda
    useEffect(() => {
        setIsDropdownOpen(false);
    }, [navigate.pathname]);

    const handleLogout = () => {
        logout();
        // Não precisa de navigate aqui, pois o App.js redireciona automaticamente
    };

    // const handleSupportClick = () => { // REMOVIDO
    //     setIsDropdownOpen(false); 
    //     setShowSupportModal(true); 
    // };

    const getLinkClass = (path) => {
        const isActive = navigate.pathname === path;
        return `${linkStyle} ${isActive ? 'bg-accent text-primary font-semibold' : ''}`;
    };

    const displayName = participanteNome ? participanteNome.split(' ')[0] : 'Perfil';

    return (
        <>
            <div className="relative" ref={dropdownRef}>
                <button 
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                    className="flex items-center space-x-2 p-2 -m-2 rounded-md hover:bg-accent/50 transition-colors"
                    aria-expanded={isDropdownOpen}
                    aria-controls="user-menu-dropdown"
                    aria-label={`Menu do Usuário: ${displayName}`}
                >
                    <User className="h-5 w-5 text-primary" />
                    <span className="text-sm font-medium text-foreground hidden sm:block">{displayName}</span>
                    <ChevronDown className={`ml-1 h-4 w-4 text-muted-foreground transition-transform duration-200 ${isDropdownOpen ? 'rotate-180' : 'rotate-0'}`} />
                </button>
                
                {isDropdownOpen && (
                    <div 
                        id="user-menu-dropdown"
                        className="absolute right-0 mt-2 w-56 bg-background border rounded-md shadow-lg z-20 origin-top-right animate-in fade-in-0 zoom-in-95"
                    >
                        {/* Header do Perfil */}
                        <div className="p-4 border-b">
                            <p className="text-sm font-semibold text-foreground">{participanteNome}</p>
                            <p className="text-xs text-muted-foreground truncate">{participanteEmail}</p>
                        </div>

                        {/* Links de Navegação */}
                        <div className="py-1">
                            <Link to="/profile" className={getLinkClass('/profile')}>
                                <Settings className="mr-2 h-4 w-4 inline-block" /> Meu Perfil
                            </Link>
                            {participanteRole !== 'ROLE_ADMIN' && (
                                <Link to="/meus-certificados" className={getLinkClass('/meus-certificados')}>
                                    <Award className="mr-2 h-4 w-4 inline-block" /> Meus Certificados
                                </Link>
                            )}
                            {/* NOVO LINK PARA A PÁGINA DE SUPORTE */}
                            <Link to="/support" className={getLinkClass('/support')}>
                                <LifeBuoy className="mr-2 h-4 w-4 inline-block" /> Suporte/Ajuda
                            </Link>
                        </div>

                        {/* Ação de Logout */}
                        <div className="border-t py-1">
                            <button 
                                onClick={handleLogout} 
                                className={`${linkStyle} w-full text-left text-destructive hover:bg-destructive/10`}
                            >
                                <LogOut className="mr-2 h-4 w-4 inline-block" /> Sair
                            </button>
                        </div>
                    </div>
                )}
            </div>
            
            {/* Modal de Suporte REMOVIDO */}
        </>
    );
}

export default UserProfileDropdown;